import { TranslationsContext } from '@execonline-inc/translations';
import { Search } from 'lucide-react';
import { observer } from 'mobx-react';
import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { translation } from '../../../../../../Translations';
import { participantSearchStore } from '../Stores/ParticipantSearchStore';

const GroupSearchFilters: React.FC = () => {
  const ts = React.useContext(TranslationsContext);
  const [localSearchValue, setLocalSearchValue] = useState(participantSearchStore.groupNameSearch);
  const debounceTimerRef = useRef<NodeJS.Timeout | null>(null);

  // Debounce search input
  const handleSearchChange = (value: string) => {
    setLocalSearchValue(value);

    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    // If search is cleared, update immediately without debouncing
    if (value.trim() === '') {
      participantSearchStore.setGroupNameSearch('');
      return;
    }

    debounceTimerRef.current = setTimeout(() => {
      participantSearchStore.setGroupNameSearch(value);
    }, 300);
  };

  // Cleanup timer on unmount
  useEffect(() => {
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, []);

  return (
    <div className="flex gap-4 mb-4" data-intercom-target="participant-search-group-filters">
      <div className="flex-1 relative">
        <input
          type="text"
          placeholder={translation('Search Group Name')(ts)}
          className="w-full px-4 py-2 pl-10 border border-border rounded-md bg-background focus:outline-none focus:ring-2 focus:ring-ring"
          value={localSearchValue}
          onChange={(e) => handleSearchChange(e.target.value)}
          data-intercom-target="participant-search-group-name-input"
        />
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
      </div>
    </div>
  );
};

export default observer(GroupSearchFilters);
